import * as AT from "src/core/products/store/products.constants";
import { IProduct } from "src/core/products/api/products.api";

export type ProductActions = ISetProduct | IPurgeProducts | ISetPriceListId | ISetPriceListEffectiveDate;

interface ISetProduct {
  type: AT.SET_PRODUCT;
  product: IProduct | null;
}

export const setProduct = (product: IProduct | null): ISetProduct => {
  return {
    type: AT.SET_PRODUCT,
    product
  };
};

interface ISetPriceListId {
  type: AT.SET_PRICE_LIST_ID;
  priceListId: number | null;
}

export const setPriceListId = (priceListId: number | null): ISetPriceListId => {
  return {
    type: AT.SET_PRICE_LIST_ID,
    priceListId
  };
};

interface ISetPriceListEffectiveDate {
  type: AT.SET_EFFECTIVE_DATE;
  effectiveDate: string | null;
}

export const setPriceListEffectiveDate = (effectiveDate: string | null): ISetPriceListEffectiveDate => {
  return {
    type: AT.SET_EFFECTIVE_DATE,
    effectiveDate
  };
};

interface IPurgeProducts {
  type: AT.PURGE_PRODUCTS;
}

export const purgeProducts = (): IPurgeProducts => {
  return { type: AT.PURGE_PRODUCTS };
};
